import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '../Card';
import EmptyRequests from './EmptyRequests';
import ShowRequests from './ShowRequests';

const useStyles = makeStyles((theme: any) => ({
  numRequestsContainer: {
    background: theme.palette.notification.main,
    borderRadius: '100%',
    width: theme.spacing(4),
    height: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  numRequests: { margin: 0, color: theme.palette.notification.text },
}));

export enum requestResponse {
  review = 0,
  approvedChangesNoRecalc,
  pendingCustomerApproval,
  customerApproved,
  customerPaymentChangeRejected,
  approved,
  rejected,
  complete,
}

export default function Requests(props) {
  const classes = useStyles();
  const { requests, setRequests } = props;

  return (
    <Card
      title="Requests"
      topRight={
        <div className={classes.numRequestsContainer}>
          <h2 className={classes.numRequests}>{requests?.length}</h2>
        </div>
      }
    >
      {requests?.length === 0 && <EmptyRequests />}
      {requests?.length > 0 &&
        requests.map((request, i) => (
          <ShowRequests
            request={request}
            requestsList={requests}
            key={i}
            setRequests={setRequests}
          />
        ))}
    </Card>
  );
}
